import axios from "axios";

type ModifyPasswordActionProps = {
  id: number;
  password: string;
  token: string;
};

export async function modifyPasswordAction(params: ModifyPasswordActionProps) {
  return await axios
    .patch(
      `${process.env.REACT_APP_API_ORIGIN}/1.0.0/user/modify-password`,
      params,
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    )
    .then((res) => res.data);
}
